var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4268"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 410",
    x: -0.000976562,
    y: 8,
    width: 27,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 412",
    x: -0.000976562,
    y: 16,
    width: 27,
    height: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 413",
    x: -0.000976562,
    width: 27,
    height: 4,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.ef6a26e96c97ef3ae04e5c5e121db8fd.svg";
export { ForwardRef as ReactComponent };